import z from 'zod';

export const AlgoliaAppId = z
  .string({
    required_error: 'ALGOLIA_APP_ID is required',
  })
  .parse(process.env.ALGOLIA_APP_ID);
export const AlgoliaRecipeIndex = z
  .string({
    required_error: 'ALGOLIA_RECIPE_INDEX is required',
  })
  .parse(process.env.ALGOLIA_RECIPE_INDEX);
export const AlgoliaGroceryIndex = z
  .string({
    required_error: 'ALGOLIA_PRODUCT_INDEX is required',
  })
  .parse(process.env.ALGOLIA_PRODUCT_INDEX);

export type AlgoliaIndexNames =
  | typeof AlgoliaRecipeIndex
  | typeof AlgoliaGroceryIndex;
